import { Capacity } from '@/features/execute-calculation-set/overmind/calculation/domain/Capacity';

import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class RatedCapacityEvaluation {
  private readonly ruleName = 'Lv_PowerTransformer_RatedCapacity';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(ratedCapacity: number | null): EvaluationResult<Capacity> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(rule?.value, ratedCapacity);
    const value = Capacity.from(ratedCapacity).toKiloVoltAmpere(); // TODO: Remove unit change from evaluation
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
